export const translations = {
  sv: {
    // Navigation
    nav: {
      home: 'Start',
      currentPrices: 'Aktuella priser',
      products: 'Produkter',
      markets: 'Här kan du köpa',
      contact: 'Kontakt',
      images: 'Bilder',
      wholesale: 'Storhandla',
      imprint: 'Imprint',
      privacy: 'Integritetspolicy'
    },
    
    // Hero Carousel
    hero: {
      ecological: 'Ekologiskt',
      tasty: 'Gott',
      local: 'Lokalt',
      marketsBtn: 'Marknader',
      productsBtn: 'Produkter',
      imagesBtn: 'Bilder'
    },
    
    // Welcome Section
    welcome: {
      title: 'Välkomna på Svansele Grönts webbplats',
      subtitle: 'Ekologisk mat från Västerbottens inland',
      findUsBtn: 'Hitta hit',
      ecologicalTitle: 'Ekologiskt och närodlat',
      hopeSee: 'Hoppas vi syns 2026!',
      cafeVisitors: 'Vårcafé besökare'
    },
    
    // Product Showcase
    productShowcase: {
      currentInStore: 'Aktuellt i butiken',
      notOnlyCarrots: 'Inte bara morötter',
      findMore: 'Hitta mer!'
    },
    
    // Why We Section
    whyWe: {
      title: 'Därför finns Svansele Grönt',
      localRaw: {
        title: 'Lokala råvaror',
        desc: 'Maten ska produceras helst där, där kunderna lever.',
        details: 'Ekologisk produktion och korta vägar förminska det ekologiska fotavtrycket. Konsumenterna känner till "sina bönder" och vet, hur maten tillverkas.'
      },
      ownProducts: {
        title: 'Egna produkter från morotsmejeriet',
        desc: 'Producera ekologiskt - förädla råvarorna själv - marknadsför direkt!',
        details: 'Utan egen förädling inget småskaligt jordbruk! Mejeriet är alltså kärnan av det framtidssäkra jordbruket.'
      },
      preserveKnowledge: {
        title: 'Bevara kunnandet - öka kunskap',
        desc: 'Alla lokala bönder är del av den strategiska försörjningssäkerheten.',
        details: 'För att finnas tillräcklig mat även i tider av exploderande bränslepriser eller andra globala transporthinder, behövs lokal kunskap och öppen jordbruksmark.'
      }
    },
    
    // Morotsmejeriet
    morotsmejeriet: {
      title: 'Morotsmejeriet',
      intro: 'Så heter våran lokal som vi arbetar i. Här kokas marmelad, såser och granskottssirap, mjölksyrar och torkar vi olika produkter, m.m.',
      fermentationTitle: 'Info om mjölksyrning',
      fermentationText: 'När grönsaker syras får probiotiska mjölksyrabakterier växa i grönsakerna. Bakterierna omvandlar socker till mjölksyra, väteperoxid och andra sura ämnen. Detta konserverar grönsakerna utan att förstöra näringsvärdet. Syrade grönsaker är bra på många sätt. De:',
      benefits: [
        'är rik på C-vitamin.',
        'innehåller nyttiga probiotiska bakterier som stärker immunförsvaret samt komplexa näringsämnen som B12-vitamin tillverkas under syrningen.',
        'sänker GI för måltiden.',
        'är lättsmält.'
      ],
      conclusion: 'C-vitamin, antioxidanter och många andra nyttiga ämnen bevaras. Samtidigt blir många nyttiga ämnen mer tillgängliga och nya komplexa näringsämnen som B12-vitamin och aminosyror bildas av de nyttiga bakterierna.',
      readMore: 'Läs mer (PDF)',
      imagePlaceholder: 'Morotsmejeriet bild'
    },
    
    // PDF Section
    pdfSection: {
      title: 'Viola Svansele Grönt',
      downloadPDF: 'Ladda ner PDF'
    },
    
    // Footer
    footer: {
      images: 'Bilder',
      imprint: 'Imprint',
      privacy: 'Integritetspolicy',
      alitero: 'En produkt från Alitero EU',
      copyright: '© 2026 Svansele Grönt. Alla rättigheter förbehållna.'
    },
    
    // Contact Page
    contact: {
      title: 'Kontakta oss',
      subtitle: 'Vi hjälper gärne till med frågor om våra produkter eller storhandel',
      sendMessage: 'Skicka meddelande',
      name: 'Namn',
      email: 'E-post',
      subject: 'Ämne',
      message: 'Meddelande',
      send: 'Skicka meddelande',
      contactInfo: 'Kontaktuppgifter',
      address: 'Adress',
      phone: 'Telefon',
      wholesaleTitle: 'Storhandel',
      wholesaleText: 'Intresserad av att köpa våra produkter i större kvantiteter? Kontakta oss för specialpriser och leveransalternativ.',
      wholesaleList: [
        'Restauranger och caféer',
        'Butiker och kooperativ',
        'Större evenemang',
        'Företagsleveranser'
      ],
      thankYou: 'Tack för ditt meddelande! Vi återkommer så snart som möjligt.'
    },
    
    // Products Page
    products: {
      title: 'Våra Produkter',
      subtitle: 'Ekologiska grönsaker',
      productImage: 'Produktbild',
      items: {
        carrots: 'Morötter',
        potatoes: 'Potatis',
        whiteCabbage: 'Vitkål',
        pointCabbage: 'Spetskål',
        sauerkraut: 'Syrade grönsaker',
        spruceSyrup: 'Granskottssirap',
        whiteTurnip: 'Vitrova',
        yellowTurnip: 'Gulrova',
        rutabaga: 'Kålrot',
        grillSauce: 'Het Rödbetsgrillsås',
        redBeetsString: 'Rödbetstråån',
        carrotString: 'Morotstråån'
      }
    },

    // Price Page
    prices: {
      title: 'Aktuella priser',
      subtitle: 'Här hittar du våra aktuella priser på ekologiska produkter från Svansele Grönt',
      inStore: 'Produkter i butiken',
      updated: 'Uppdaterat',
      inStock: 'I lager',
      orderItem: 'Beställningsvara',
      seasonal: 'Säsongvara',
      limited: 'Begränsat',
      priceInfo: 'Prisinformation',
      general: 'Allmänt',
      generalList: [
        'Alla priser inkluderar moms',
        'Säsongspriser kan variera',
        'Färskhetsdatum garanteras'
      ],
      wholesale: 'Storhandel',
      wholesaleList: [
        'Rabatt vid köp över 500 kr',
        'Specialpriser för återförsäljare',
        'Kontakta oss för offert'
      ],
      note: 'Obs: Priserna kan variera beroende på säsong och tillgänglighet. Kontakta oss för de mest aktuella priserna eller för större beställningar.',
      products: {
        carrot: 'Morot',
        fodderCarrot: 'Foder-Morot',
        potato: 'Potatis – Gala, Nicola, Connect',
        potatoDitta: 'Potatis – Ditta',
        almonPotato: 'Mandelpotatis',
        pointCabbage: 'Spetskål',
        whiteCabbage: 'Vitkål',
        redCabbage: 'Rödkål',
        rutabaga: 'Kålrot',
        turnip: 'Rova – vit eller gul',
        fermentedWhiteCabbage: 'Syrad vitkål',
        fermentedWhiteCabbageBottle: 'Syrad vitkål (inkl. 15: - pant)',
        fermentedCarrot: 'Syrad morot',
        fermentedMixed: 'Syrad morot/vitkål',
        beetsString: 'Rödbetstråån med lakrits',
        carrotString: 'Morotstråån med havtorn',
        grillSauce: 'Het Rödbetsgrillsås',
        carrotSyrup: 'Het morotsserap',
        spruceSyrup: 'Granskottssirap',
        beetsKvass: 'Rödbetskvass',
        carrotJuice: 'Morotsjuice (fryst eller färskt)',
        vegetableBroth: 'Grönsaksbuljong',
        redBeetsString: 'Rödbetstråån',
        carrotStringName: 'Morotstråån'
      }
    },
    
    // Markets Page
    markets: {
      farmShop: 'är öppet dygnet runt. Här finns allt från gården och litet till. Gården finns i Svansele 2, 935 93 Norsjö.',
      lovanger: 'Kungsvägen 28, 932 61 Lövånger, måndag – fredag: kl 10 - 18, lördag: kl 11 - 15. Besök',
      burtrask: 'Vasabrogatan 3, har öppet tre dagar i veckan. Torsdag och fredag kl 10-18 och lördagar kl 10-14. Besök',
      skelleftea: 'äger rum torsdagarna under ojämna veckor kl 18.00-18.30 på Tipshusparkeringen Anderstorp. Beställ via FB!',
      kusfors: 'Björks Lanthandel, Kusfors 33, 936 93 Boliden. Öppettider: måndag–torsdag 09.30–18.00, fredag 09.30–19.00, lördag 09.30–16.00, söndag 12.00–16.00.',
      adak: 'Slagnäsvägen 5, 939 92 Adak, måndag – fredag: kl 10 - 17.30, lördag: kl 10 - 12, söndag: kl 16 - 17.',
      wholesaleTitle: 'Du som vill storhandla',
      wholesaleText: 'Skicka din förfråga, beställning aller önskan om offert till:',
      wholesaleBtn: 'storhandla',
      website: 'butikens webbsajt!',
      farmShopName: 'Gårdsbutiken',
      lovangerName: 'Lövånger Saluhall',
      burtraskName: 'Saluhallen i Burträsk (tillfälligt stängd)',
      skellefteaName: 'Rekoringen i Skellefteå',
      kusforsName: 'ICA Kusfors',
      adakName: 'Handlaren i Adak',
      glommerstrak: 'Finnbergs, Storgatan 90, 933 94 Glommersträsk, måndag – fredag: kl 9 - 18.30, lördag: kl 9 - 13, söndag: stängt.',
      glommerstrakName: 'Handlaren i Glommersträsk',
      farmup: 'Den bästa maten finns nära dig. Handla direkt från matproducenter i ditt område.',
      farmupName: 'Farmup (snart)'
    },

    // Images Page
    images: {
      title: 'Bilder',
      subtitle: 'En visuell resa genom Svansele Grönt - från vår ekologiska odling till färdiga produkter och marknadsplatser',
      allImages: 'Alla Bilder',
      branding: 'Varumärke',
      products: 'Produkter',
      farm: 'Gård & Odling',
      production: 'Morotsmejeriet',
      market: 'Marknader',
      events: 'Event',
      followUs: 'Följ oss på sociala medier',
      followText: 'Håll dig uppdaterad med allt som händer på Svansele Grönt - från dagliga skördar till nya produkter och marknadsevent'
    },
    
    // Wholesale Page
    wholesalePage: {
      title: 'Kontakta oss!',
      myNameIs: 'Mit namn är',
      yourName: 'Ditt namn',
      iAm: 'Jag är',
      restaurateur: 'krögare',
      largeKitchen: 'ett storhushåll',
      privateCustomer: 'privatkund',
      iWant: 'Jag vill',
      order: 'beställa',
      quote: 'ha en offert',
      regarding: 'Det gäller',
      carrots: 'Morötter',
      potatoes: 'Potatis',
      goodies: 'Goodies',
      spruceTipSyrup: 'Granskottssirap',
      grillSauce: 'Grillssås',
      other: 'Annat',
      quantityNote: 'Snälla ange kvantiteten nere under "Meddelande"!',
      emailAddress: 'E-post-adress',
      message: 'Meddelande',
      messagePlaceholder: 'Ditt meddelande, inklusive önskad kvantitet...',
      day: 'Dag',
      submit: 'Skicka iväg',
      email: 'E-post',
      phone: 'Telefon',
      address: 'Adress',
      thankYou: 'Tack för din förfrågan! Vi kontaktar dig snart.'
    },
    
    // Imprint Page
    imprint: {
      title: 'Imprint',
      companyInfo: 'Företagsinformation',
      contact: 'Kontakt',
      phone: 'Telefon',
      email: 'E-post',
      website: 'Webbplats',
      legalRep: 'Ansvarig utgivare',
      legalRepText: 'Innehållsansvarig enligt § 55 RStV:',
      disclaimer: 'Ansvarsfriskrivning',
      contentLiability: 'Ansvar för innehåll',
      contentLiabilityText: 'Som tjänsteleverantör ansvarar vi för eget innehåll på dessa sidor i enlighet med allmänna lagar. Vi är dock inte skyldiga att övervaka överförd eller lagrad information från tredje part eller att utreda omständigheter som tyder på olaglig verksamhet.',
      linkLiability: 'Ansvar för länkar',
      linkLiabilityText: 'Vårt erbjudande innehåller länkar till externa webbplatser från tredje part, vars innehåll vi inte har något inflytande över. Därför kan vi inte ta något ansvar för detta externa innehåll. För innehållet på de länkade sidorna ansvarar alltid respektive leverantör eller operatör av sidorna.',
      copyright: 'Upphovsrätt',
      copyrightText: 'Innehållet och verken på dessa sidor som skapats av webbplatsoperatörerna omfattas av upphovsrättslagen. Kopiering, bearbetning, distribution och all form av utnyttjande utanför upphovsrättens gränser kräver skriftligt medgivande från respektive författare eller skapare.',
      imageCredits: 'Bildkällor',
      imageCreditsText: 'Bilder och grafik som används på denna webbplats kommer från:',
      imageSourcesList: [
        'Eget material (Svansele Grönt)',
        'Unsplash (Placeholder-bilder)',
        'Leaflet / OpenStreetMap (Kartdata)'
      ]
    },
    
    // Privacy Page
    privacy: {
      title: 'Integritetspolicy',
      intro: 'Introduktion',
      introText1: 'Hos Svansele Grönt värnar vi om din personliga integritet. Denna integritetspolicy beskriver hur vi samlar in, använder och skyddar dina personuppgifter när du besöker vår webbplats www.svanselegront.se eller kontaktar oss för beställningar och frågor.',
      introText2: 'Vi är skyldiga att följa Dataskyddslagen (GDPR) och andra relevanta lagar när vi behandlar dina personuppgifter.',
      dataCollection: 'Vilka uppgifter samlar vi in?',
      contactForms: 'Kontaktformulär och beställningar',
      contactFormsList: [
        'Namn',
        'E-postadress',
        'Telefonnummer (frivilligt)',
        'Adress (för leveranser)',
        'Beställningsinformation',
        'Meddelanden och frågor'
      ],
      websiteUsage: 'Webbplatsanvändning',
      websiteUsageList: [
        'IP-adress (för säkerhetsändamål)',
        'Webbläsartyp och version',
        'Operativsystem',
        'Refererande webbplatser',
        'Besöksdatum och tid'
      ],
      dataUse: 'Hur vi använder dina uppgifter',
      dataUseText: 'Vi använder dina personuppgifter för följande ändamål:',
      dataUseList: [
        'För att hantera och genomföra dina beställningar',
        'För att svara på dina frågor och förfrågningar',
        'För att förbättra våra produkter och tjänster',
        'För att kommunicera med dig angående leveranser och nyheter',
        'För att följa gällande lagar och förordningar'
      ],
      dataSharing: 'Delning av uppgifter',
      dataSharingText: 'Vi säljer eller hyr aldrig ut dina personuppgifter till tredje part. Vi delar endast dina uppgifter i följande situationer:',
      dataSharingList: [
        'När det är nödvändigt för att genomföra en beställning (t.ex. till transportör)',
        'När vi är skyldiga att göra det enligt lag',
        'När du har gett ditt uttryckliga samtycke'
      ],
      dataStorage: 'Lagring av uppgifter',
      dataStorageText1: 'Dina personuppgifter lagras endast så länge det är nödvändigt för de ändamål de samlades in för. Vi vidtar lämpliga tekniska och organisatoriska åtgärder för att skydda dina uppgifter mot obehörig åtkomst, förlust eller förstörelse.',
      dataStorageText2: 'Kontaktformulär och beställningar spars i maximalt 2 år efter senaste aktivitet, om inte längre lagring krävs enligt lag.',
      yourRights: 'Dina rättigheter',
      yourRightsText: 'Enligt GDPR har du följande rättigheter gällande dina personuppgifter:',
      yourRightsList: [
        'Rätt att få information om vilka uppgifter vi behandlar om dig',
        'Rätt att begära rättelse av felaktiga uppgifter',
        'Rätt att begära radering av dina uppgifter',
        'Rätt att begränsa behandlingen av dina uppgifter',
        'Rätt att motsätta dig behandling',
        'Rätt att dataportabilitet'
      ],
      yourRightsFooter: 'För att utöva dessa rättigheter, kontakta oss via informationen nedan.',
      cookies: 'Cookies',
      cookiesText1: 'Vår webbplats använder endast nödvändiga cookies för grundläggande funktioner, såsom navigation och grundläggande säkerhet. Vi använder inte cookies för spårning eller marknadsföring.',
      cookiesText2: 'Du kan välja att avvisa cookies genom att ändra inställningarna i din webbläsare.',
      contactInfo: 'Kontakt',
      contactInfoText: 'Om du har frågor om vår integritetspolicy eller hur vi behandlar dina personuppgifter, kontakta oss:',
      changes: 'Ändringar i policyn',
      changesText1: 'Vi kan uppdatera denna integritetspolicy från tid till annan. Eventuella ändringar kommer att publiceras på denna sida med datum för senaste uppdatering.',
      changesText2: 'Senast uppdaterad:'
    }
  },
  
  en: {
    // PDF Section
    pdfSection: {
      title: 'Viola Svansele Grönt',
      downloadPDF: 'Download PDF'
    },
    
    // Navigation
    nav: {
      home: 'Home',
      currentPrices: 'Current Prices',
      products: 'Products',
      markets: 'Where to Buy',
      contact: 'Contact',
      images: 'Images',
      wholesale: 'Wholesale',
      imprint: 'Imprint',
      privacy: 'Privacy Policy'
    },
    
    // Hero Carousel
    hero: {
      ecological: 'Ecological',
      tasty: 'Delicious',
      local: 'Local',
      marketsBtn: 'Markets',
      productsBtn: 'Products',
      imagesBtn: 'Images'
    },
    
    // Welcome Section
    welcome: {
      title: 'Welcome to Svansele Grönt\'s Website',
      subtitle: 'Organic food from the Västerbotten inland',
      findUsBtn: 'Find Us',
      ecologicalTitle: 'Ecological and Locally Grown',
      hopeSee: 'Hope to see you in 2026!',
      cafeVisitors: 'Spring café visitors'
    },
    
    // Product Showcase
    productShowcase: {
      currentInStore: 'Currently in Store',
      notOnlyCarrots: 'Not Just Carrots',
      findMore: 'Find More!'
    },
    
    // Why We Section
    whyWe: {
      title: 'Why Svansele Grönt Exists',
      localRaw: {
        title: 'Local Raw Materials',
        desc: 'Food should be produced where the customers live.',
        details: 'Organic production and short distances minimize the ecological footprint. Consumers know "their farmers" and understand how the food is made.'
      },
      ownProducts: {
        title: 'Own Products from the Carrot Dairy',
        desc: 'Produce organically - process raw materials yourself - market directly!',
        details: 'Without own processing, no small-scale farming! The dairy is therefore the core of future-proof agriculture.'
      },
      preserveKnowledge: {
        title: 'Preserve Knowledge - Increase Awareness',
        desc: 'All local farmers are part of strategic food security.',
        details: 'To have sufficient food even in times of exploding fuel prices or other global transport barriers, local knowledge and open farmland are needed.'
      }
    },
    
    // Morotsmejeriet
    morotsmejeriet: {
      title: 'The Carrot Dairy',
      intro: 'That\'s the name of our facility where we work. Here we cook jam, sauces and spruce tip syrup, ferment and dry various products, etc.',
      fermentationTitle: 'About Lacto-Fermentation',
      fermentationText: 'When vegetables are fermented, probiotic lactic acid bacteria grow in the vegetables. The bacteria convert sugar into lactic acid, hydrogen peroxide and other acidic substances. This preserves the vegetables without destroying their nutritional value. Fermented vegetables are beneficial in many ways. They:',
      benefits: [
        'are rich in vitamin C.',
        'contain beneficial probiotic bacteria that strengthen the immune system, and complex nutrients such as vitamin B12 are produced during fermentation.',
        'lower the GI of the meal.',
        'are easily digestible.'
      ],
      conclusion: 'Vitamin C, antioxidants and many other beneficial substances are preserved. At the same time, many beneficial substances become more available and new complex nutrients such as vitamin B12 and amino acids are formed by the beneficial bacteria.',
      readMore: 'Read More (PDF)',
      imagePlaceholder: 'Carrot Dairy image'
    },
    
    // Footer
    footer: {
      images: 'Images',
      imprint: 'Imprint',
      privacy: 'Privacy Policy',
      alitero: 'A product from Alitero EU',
      copyright: '© 2026 Svansele Grönt. All rights reserved.'
    },
    
    // Contact Page
    contact: {
      title: 'Contact Us',
      subtitle: 'We are happy to help with questions about our products or wholesale',
      sendMessage: 'Send Message',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      contactInfo: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      wholesaleTitle: 'Wholesale',
      wholesaleText: 'Interested in purchasing our products in larger quantities? Contact us for special prices and delivery options.',
      wholesaleList: [
        'Restaurants and cafés',
        'Stores and cooperatives',
        'Larger events',
        'Corporate deliveries'
      ],
      thankYou: 'Thank you for your message! We will get back to you as soon as possible.'
    },
    
    // Products Page
    products: {
      title: 'Our Products',
      subtitle: 'Organic vegetables',
      productImage: 'Product image',
      items: {
        carrots: 'Carrots',
        potatoes: 'Potatoes',
        whiteCabbage: 'White Cabbage',
        pointCabbage: 'Pointed Cabbage',
        sauerkraut: 'Sauerkraut',
        spruceSyrup: 'Spruce Tip Syrup',
        whiteTurnip: 'White Turnip',
        yellowTurnip: 'Yellow Turnip',
        rutabaga: 'Rutabaga',
        grillSauce: 'Hot Beets Grill Sauce',
        redBeetsString: 'Rödbetstråån',
        carrotString: 'Morotstråån'
      }
    },

    // Price Page
    prices: {
      title: 'Current Prices',
      subtitle: 'Here you can find our current prices for organic products from Svansele Grönt',
      inStore: 'Products in Store',
      updated: 'Updated',
      inStock: 'In Stock',
      orderItem: 'Order Item',
      seasonal: 'Seasonal',
      limited: 'Limited',
      priceInfo: 'Price Information',
      general: 'General',
      generalList: [
        'All prices include VAT',
        'Seasonal prices may vary',
        'Freshness date guaranteed'
      ],
      wholesale: 'Wholesale',
      wholesaleList: [
        'Discount on purchases over 500 kr',
        'Special prices for retailers',
        'Contact us for a quote'
      ],
      note: 'Note: Prices may vary depending on season and availability. Contact us for the most current prices or for larger orders.',
      products: {
        carrot: 'Carrots',
        fodderCarrot: 'Fodder Carrots',
        potato: 'Potatoes – Gala, Nicola, Connect',
        potatoDitta: 'Potatoes – Ditta',
        almonPotato: 'Almond Potatoes',
        pointCabbage: 'Pointed Cabbage',
        whiteCabbage: 'White Cabbage',
        redCabbage: 'Red Cabbage',
        rutabaga: 'Rutabaga',
        turnip: 'Turnip – White or Yellow',
        fermentedWhiteCabbage: 'Sauerkraut',
        fermentedWhiteCabbageBottle: 'Sauerkraut (incl. 15: - deposit)',
        fermentedCarrot: 'Fermented Carrots',
        fermentedMixed: 'Fermented Carrots/Sauerkraut',
        beetsString: 'Rödbetstråån med lakrits',
        carrotString: 'Morotstråån med havtorn',
        grillSauce: 'Hot Beets Grill Sauce',
        carrotSyrup: 'Hot Carrot Syrup',
        spruceSyrup: 'Spruce Tip Syrup',
        beetsKvass: 'Beets Kvass',
        carrotJuice: 'Carrot Juice (Frozen or Fresh)',
        vegetableBroth: 'Vegetable Broth',
        redBeetsString: 'Rödbetstråån',
        carrotStringName: 'Morotstråån'
      }
    },
    
    // Markets Page
    markets: {
      farmShop: 'is open 24/7. Here you can find everything from the farm and more. The farm is located at Svansele 2, 935 93 Norsjö.',
      lovanger: 'Kungsvägen 28, 932 61 Lövånger, Monday – Friday: 10 AM - 6 PM, Saturday: 11 AM - 3 PM. Visit',
      burtrask: 'Vasabrogatan 3, is open three days a week. Thursday and Friday 10 AM-6 PM and Saturdays 10 AM-2 PM. Visit',
      skelleftea: 'takes place on Thursdays during odd weeks at 6:00-6:30 PM at Tipshusparkeringen Anderstorp. Order via FB!',
      kusfors: 'Björks Lanthandel, Kusfors 33, 936 93 Boliden. Opening hours: Monday–Thursday 9:30 AM–6:00 PM, Friday 9:30 AM–7:00 PM, Saturday 9:30 AM–4:00 PM, Sunday 12:00–4:00 PM.',
      adak: 'Slagnäsvägen 5, 939 92 Adak, Monday – Friday: 10 AM - 5:30 PM, Saturday: 10 AM - 12 PM, Sunday: 4 PM - 5 PM.',
      wholesaleTitle: 'For Wholesale Customers',
      wholesaleText: 'Send your inquiry, order or request for a quote to:',
      wholesaleBtn: 'wholesale',
      website: 'the store\'s website!',
      farmShopName: 'The Farm Shop',
      lovangerName: 'Lövånger Food Hall',
      burtraskName: 'The Food Hall in Burträsk (temporarily closed)',
      skellefteaName: 'The Reko Ring in Skellefteå',
      kusforsName: 'ICA Kusfors',
      adakName: 'The Trader in Adak',
      glommerstrak: 'Finnbergs, Storgatan 90, 933 94 Glommersträsk, Monday – Friday: 9 AM - 6:30 PM, Saturday: 9 AM - 1 PM, Sunday: closed.',
      glommerstrakName: 'The Trader in Glommersträsk',
      farmup: 'The best food is near you. Shop directly from food producers in your area.',
      farmupName: 'Farmup (coming soon)'
    },

    // Images Page
    images: {
      title: 'Images',
      subtitle: 'A visual journey through Svansele Grönt - from our organic farming to finished products and marketplaces',
      allImages: 'All Images',
      branding: 'Branding',
      products: 'Products',
      farm: 'Farm & Cultivation',
      production: 'Carrot Dairy',
      market: 'Markets',
      events: 'Events',
      followUs: 'Follow us on social media',
      followText: 'Stay updated with everything happening at Svansele Grönt - from daily harvests to new products and market events'
    },
    
    // Wholesale Page
    wholesalePage: {
      title: 'Contact Us!',
      myNameIs: 'My name is',
      yourName: 'Your name',
      iAm: 'I am',
      restaurateur: 'a restaurateur',
      largeKitchen: 'a large kitchen',
      privateCustomer: 'a private customer',
      iWant: 'I want',
      order: 'to order',
      quote: 'a quote',
      regarding: 'Regarding',
      carrots: 'Carrots',
      potatoes: 'Potatoes',
      goodies: 'Goodies',
      spruceTipSyrup: 'Spruce Tip Syrup',
      grillSauce: 'Grill Sauce',
      other: 'Other',
      quantityNote: 'Please specify the quantity in the "Message" field below!',
      emailAddress: 'Email Address',
      message: 'Message',
      messagePlaceholder: 'Your message, including desired quantity...',
      day: 'Date',
      submit: 'Send',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      thankYou: 'Thank you for your inquiry! We will contact you soon.'
    },
    
    // Imprint Page
    imprint: {
      title: 'Imprint',
      companyInfo: 'Company Information',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      legalRep: 'Legal Representative',
      legalRepText: 'Responsible for content according to § 55 RStV:',
      disclaimer: 'Disclaimer',
      contentLiability: 'Liability for Content',
      contentLiabilityText: 'As a service provider, we are responsible for our own content on these pages in accordance with general laws. However, we are not obligated to monitor transmitted or stored information from third parties or to investigate circumstances that indicate illegal activity.',
      linkLiability: 'Liability for Links',
      linkLiabilityText: 'Our offer contains links to external websites of third parties, over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the pages is always responsible for the content of the linked pages.',
      copyright: 'Copyright',
      copyrightText: 'The content and works on these pages created by the site operators are subject to copyright law. Copying, editing, distribution and any form of exploitation outside the limits of copyright require the written consent of the respective author or creator.',
      imageCredits: 'Image Sources',
      imageCreditsText: 'Images and graphics used on this website come from:',
      imageSourcesList: [
        'Own material (Svansele Grönt)',
        'Unsplash (Placeholder images)',
        'Leaflet / OpenStreetMap (Map data)'
      ]
    },
    
    // Privacy Page
    privacy: {
      title: 'Privacy Policy',
      intro: 'Introduction',
      introText1: 'At Svansele Grönt, we care about your personal privacy. This privacy policy describes how we collect, use and protect your personal data when you visit our website www.svanselegront.se or contact us for orders and inquiries.',
      introText2: 'We are obliged to comply with the Data Protection Act (GDPR) and other relevant laws when processing your personal data.',
      dataCollection: 'What data do we collect?',
      contactForms: 'Contact forms and orders',
      contactFormsList: [
        'Name',
        'Email address',
        'Phone number (optional)',
        'Address (for deliveries)',
        'Order information',
        'Messages and inquiries'
      ],
      websiteUsage: 'Website usage',
      websiteUsageList: [
        'IP address (for security purposes)',
        'Browser type and version',
        'Operating system',
        'Referring websites',
        'Visit date and time'
      ],
      dataUse: 'How we use your data',
      dataUseText: 'We use your personal data for the following purposes:',
      dataUseList: [
        'To manage and execute your orders',
        'To respond to your questions and inquiries',
        'To improve our products and services',
        'To communicate with you regarding deliveries and news',
        'To comply with applicable laws and regulations'
      ],
      dataSharing: 'Data sharing',
      dataSharingText: 'We never sell or rent your personal data to third parties. We only share your data in the following situations:',
      dataSharingList: [
        'When necessary to execute an order (e.g., to a carrier)',
        'When we are required to do so by law',
        'When you have given your explicit consent'
      ],
      dataStorage: 'Data storage',
      dataStorageText1: 'Your personal data is only stored as long as necessary for the purposes for which it was collected. We take appropriate technical and organizational measures to protect your data against unauthorized access, loss or destruction.',
      dataStorageText2: 'Contact forms and orders are stored for a maximum of 2 years after the last activity, unless longer storage is required by law.',
      yourRights: 'Your rights',
      yourRightsText: 'According to GDPR, you have the following rights regarding your personal data:',
      yourRightsList: [
        'Right to information about what data we process about you',
        'Right to request correction of incorrect data',
        'Right to request deletion of your data',
        'Right to restrict the processing of your data',
        'Right to object to processing',
        'Right to data portability'
      ],
      yourRightsFooter: 'To exercise these rights, contact us using the information below.',
      cookies: 'Cookies',
      cookiesText1: 'Our website only uses necessary cookies for basic functions, such as navigation and basic security. We do not use cookies for tracking or marketing.',
      cookiesText2: 'You can choose to reject cookies by changing the settings in your browser.',
      contactInfo: 'Contact',
      contactInfoText: 'If you have questions about our privacy policy or how we process your personal data, contact us:',
      changes: 'Changes to the policy',
      changesText1: 'We may update this privacy policy from time to time. Any changes will be published on this page with the date of the last update.',
      changesText2: 'Last updated:'
    }
  },
  
  de: {
    // PDF Section
    pdfSection: {
      title: 'Viola Svansele Grönt',
      downloadPDF: 'PDF herunterladen'
    },
    
    // Navigation
    nav: {
      home: 'Startseite',
      currentPrices: 'Aktuelle Preise',
      products: 'Produkte',
      markets: 'Wo kaufen',
      contact: 'Kontakt',
      images: 'Bilder',
      wholesale: 'Großhandel',
      imprint: 'Impressum',
      privacy: 'Datenschutz'
    },
    
    // Hero Carousel
    hero: {
      ecological: 'Ökologisch',
      tasty: 'Lecker',
      local: 'Lokal',
      marketsBtn: 'Märkte',
      productsBtn: 'Produkte',
      imagesBtn: 'Bilder'
    },
    
    // Welcome Section
    welcome: {
      title: 'Willkommen auf der Website von Svansele Grönt',
      subtitle: 'Bio-Lebensmittel aus dem Hinterland von Västerbotten',
      findUsBtn: 'Finden Sie uns',
      ecologicalTitle: 'Ökologisch und regional angebaut',
      hopeSee: 'Wir hoffen, Sie 2026 zu sehen!',
      cafeVisitors: 'Frühlingscafé-Besucher'
    },
    
    // Product Showcase
    productShowcase: {
      currentInStore: 'Aktuell im Laden',
      notOnlyCarrots: 'Nicht nur Karotten',
      findMore: 'Mehr entdecken!'
    },
    
    // Why We Section
    whyWe: {
      title: 'Warum es Svansele Grönt gibt',
      localRaw: {
        title: 'Lokale Rohstoffe',
        desc: 'Lebensmittel sollten dort produziert werden, wo die Kunden leben.',
        details: 'Ökologische Produktion und kurze Wege minimieren den ökologischen Fußabdruck. Die Verbraucher kennen "ihre Bauern" und wissen, wie die Lebensmittel hergestellt werden.'
      },
      ownProducts: {
        title: 'Eigene Produkte aus der Möhrenmeierei',
        desc: 'Ökologisch produzieren - Rohstoffe selbst verarbeiten - direkt vermarkten!',
        details: 'Ohne eigene Verarbeitung keine kleinbäuerliche Landwirtschaft! Die Molkerei ist daher der Kern der zukunftssicheren Landwirtschaft.'
      },
      preserveKnowledge: {
        title: 'Wissen bewahren - Bewusstsein erhöhen',
        desc: 'Alle lokalen Bauern sind Teil der strategischen Ernährungssicherheit.',
        details: 'Um auch in Zeiten explodierender Kraftstoffpreise oder anderer globaler Transportbarrieren ausreichend Lebensmittel zu haben, sind lokales Wissen und offenes Ackerland erforderlich.'
      }
    },
    
    // Morotsmejeriet
    morotsmejeriet: {
      title: 'Die Möhrenmeierei',
      intro: 'So heißt unsere Einrichtung, in der wir arbeiten. Hier kochen wir Marmelade, Saucen und Fichtenwipfelsirup, fermentieren und trocknen verschiedene Produkte usw.',
      fermentationTitle: 'Über Milchsäuregärung',
      fermentationText: 'Wenn Gemüse fermentiert wird, wachsen probiotische Milchsäurebakterien im Gemüse. Die Bakterien wandeln Zucker in Milchsäure, Wasserstoffperoxid und andere saure Substanzen um. Dies konserviert das Gemüse ohne seinen Nährwert zu zerstören. Fermentiertes Gemüse ist auf vielfältige Weise vorteilhaft. Es:',
      benefits: [
        'ist reich an Vitamin C.',
        'enthält nützliche probiotische Bakterien, die das Immunsystem stärken, und komplexe Nährstoffe wie Vitamin B12 werden während der Fermentation produziert.',
        'senkt den GI der Mahlzeit.',
        'ist leicht verdaulich.'
      ],
      conclusion: 'Vitamin C, Antioxidantien und viele andere nützliche Substanzen bleiben erhalten. Gleichzeitig werden viele nützliche Substanzen verfügbarer und neue komplexe Nährstoffe wie Vitamin B12 und Aminosäuren werden von den nützlichen Bakterien gebildet.',
      readMore: 'Mehr lesen (PDF)',
      imagePlaceholder: 'Möhrenmeierei Bild'
    },
    
    // Footer
    footer: {
      images: 'Bilder',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      alitero: 'Ein Produkt von Alitero EU',
      copyright: '© 2026 Svansele Grönt. Alle Rechte vorbehalten.'
    },
    
    // Contact Page
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir helfen gerne bei Fragen zu unseren Produkten oder zum Großhandel',
      sendMessage: 'Nachricht senden',
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Nachricht senden',
      contactInfo: 'Kontaktinformationen',
      address: 'Adresse',
      phone: 'Telefon',
      wholesaleTitle: 'Großhandel',
      wholesaleText: 'Interessiert am Kauf unserer Produkte in größeren Mengen? Kontaktieren Sie uns für Sonderpreise und Lieferoptionen.',
      wholesaleList: [
        'Restaurants und Cafés',
        'Geschäfte und Genossenschaften',
        'Größere Veranstaltungen',
        'Unternehmenslieferungen'
      ],
      thankYou: 'Vielen Dank für Ihre Nachricht! Wir melden uns so schnell wie möglich bei Ihnen.'
    },
    
    // Products Page
    products: {
      title: 'Unsere Produkte',
      subtitle: 'Bio-Gemüse',
      productImage: 'Produktbild',
      items: {
        carrots: 'Karotten',
        potatoes: 'Kartoffeln',
        whiteCabbage: 'Weißkohl',
        pointCabbage: 'Spitzkohl',
        sauerkraut: 'Sauerkraut',
        spruceSyrup: 'Fichtensprossensirup',
        whiteTurnip: 'Weiße Rübe',
        yellowTurnip: 'Gelbe Rübe',
        rutabaga: 'Kohlrübe',
        grillSauce: 'Heiße Rote-Beete-Grillsoße',
        redBeetsString: 'Rödbetstråån',
        carrotString: 'Morotstråån'
      }
    },

    // Price Page
    prices: {
      title: 'Aktuelle Preise',
      subtitle: 'Hier finden Sie unsere aktuellen Preise für Bio-Produkte von Svansele Grönt',
      inStore: 'Produkte im Laden',
      updated: 'Aktualisiert',
      inStock: 'Auf Lager',
      orderItem: 'Bestellartikel',
      seasonal: 'Saisonal',
      limited: 'Begrenzt',
      priceInfo: 'Preisinformationen',
      general: 'Allgemein',
      generalList: [
        'Alle Preise inkl. MwSt.',
        'Saisonpreise können variieren',
        'Frischedatum garantiert'
      ],
      wholesale: 'Großhandel',
      wholesaleList: [
        'Rabatt bei Einkauf über 500 kr',
        'Sonderpreise für Händler',
        'Kontaktieren Sie uns für ein Angebot'
      ],
      note: 'Hinweis: Die Preise können je nach Saison und Verfügbarkeit variieren. Kontaktieren Sie uns für die aktuellsten Preise oder für größere Bestellungen.',
      products: {
        carrot: 'Karotten',
        fodderCarrot: 'Futter-Karotten',
        potato: 'Kartoffeln – Gala, Nicola, Connect',
        potatoDitta: 'Kartoffeln – Ditta',
        almonPotato: 'Mandel-Kartoffeln',
        pointCabbage: 'Spitzkohl',
        whiteCabbage: 'Weißkohl',
        redCabbage: 'Rotkohl',
        rutabaga: 'Kohlrübe',
        turnip: 'Rübe – weiß oder gelb',
        fermentedWhiteCabbage: 'Sauerkraut',
        fermentedWhiteCabbageBottle: 'Sauerkraut (inkl. 15: - Pfand)',
        fermentedCarrot: 'Fermentierte Karotten',
        fermentedMixed: 'Fermentierte Karotten/Sauerkraut',
        beetsString: 'Rödbetstråån med lakrits',
        carrotString: 'Morotstråån med havtorn',
        grillSauce: 'Heißes Rote-Beete-Grillsoße',
        carrotSyrup: 'Heißes Karottensirup',
        spruceSyrup: 'Fichtensprossensirup',
        beetsKvass: 'Rote-Beete-Kwas',
        carrotJuice: 'Karottensaft (frisch oder gefroren)',
        vegetableBroth: 'Gemüsebouillon',
        redBeetsString: 'Rödbetstråån',
        carrotStringName: 'Morotstråån'
      }
    },
    
    // Markets Page
    markets: {
      farmShop: 'ist rund um die Uhr geöffnet. Hier finden Sie alles vom Hof und mehr. Der Hof befindet sich in Svansele 2, 935 93 Norsjö.',
      lovanger: 'Kungsvägen 28, 932 61 Lövånger, Montag – Freitag: 10-18 Uhr, Samstag: 11-15 Uhr. Besuchen Sie',
      burtrask: 'Vasabrogatan 3, ist drei Tage die Woche geöffnet. Donnerstag und Freitag 10-18 Uhr und Samstags 10-14 Uhr. Besuchen Sie',
      skelleftea: 'findet donnerstags in ungeraden Wochen um 18:00-18:30 Uhr auf dem Tipshusparkeringen Anderstorp statt. Bestellen Sie über FB!',
      kusfors: 'Björks Lanthandel, Kusfors 33, 936 93 Boliden. Öffnungszeiten: Montag–Donnerstag 9:30–18:00 Uhr, Freitag 9:30–19:00 Uhr, Samstag 9:30–16:00 Uhr, Sonntag 12:00–16:00 Uhr.',
      adak: 'Slagnäsvägen 5, 939 92 Adak, Montag – Freitag: 10-17:30 Uhr, Samstag: 10-12 Uhr, Sonntag: 16-17 Uhr.',
      wholesaleTitle: 'Für Großhandelskunden',
      wholesaleText: 'Senden Sie Ihre Anfrage, Bestellung oder Angebotsanfrage an:',
      wholesaleBtn: 'Großhandel',
      website: 'die Website des Geschäfts!',
      farmShopName: 'Hofladen',
      lovangerName: 'Lövånger Markthalle',
      burtraskName: 'Markthalle in Burträsk (vorläufig geschlossen)',
      skellefteaName: 'Reko-Ring in Skellefteå',
      kusforsName: 'ICA Kusfors',
      adakName: 'Händler in Adak',
      glommerstrak: 'Finnbergs, Storgatan 90, 933 94 Glommersträsk, Montag – Freitag: 9-18:30 Uhr, Samstag: 9-13 Uhr, Sonntag: geschlossen.',
      glommerstrakName: 'Händler in Glommersträsk',
      farmup: 'Das beste Essen ist in deiner Nähe. Kaufe direkt bei Lebensmittelproduzenten in deiner Region.',
      farmupName: 'Farmup (demnächst)'
    },

    // Images Page
    images: {
      title: 'Bilder',
      subtitle: 'Eine visuelle Reise durch Svansele Grönt - von unserer Bio-Landwirtschaft bis zu fertigen Produkten und Marktplätzen',
      allImages: 'Alle Bilder',
      branding: 'Markenbildung',
      products: 'Produkte',
      farm: 'Hof & Anbau',
      production: 'Möhrenmeierei',
      market: 'Märkte',
      events: 'Veranstaltungen',
      followUs: 'Folgen Sie uns in den sozialen Medien',
      followText: 'Bleiben Sie auf dem Laufenden über alles, was bei Svansele Grönt passiert - von täglichen Ernten bis zu neuen Produkten und Marktveranstaltungen'
    },
    
    // Wholesale Page
    wholesalePage: {
      title: 'Kontaktieren Sie uns!',
      myNameIs: 'Mein Name ist',
      yourName: 'Ihr Name',
      iAm: 'Ich bin',
      restaurateur: 'Gastronom',
      largeKitchen: 'Großküche',
      privateCustomer: 'Privatkunde',
      iWant: 'Ich möchte',
      order: 'bestellen',
      quote: 'ein Angebot',
      regarding: 'Betreffend',
      carrots: 'Karotten',
      potatoes: 'Kartoffeln',
      goodies: 'Leckereien',
      spruceTipSyrup: 'Fichtenwipfelsirup',
      grillSauce: 'Grillsoße',
      other: 'Sonstiges',
      quantityNote: 'Bitte geben Sie die Menge im Feld "Nachricht" unten an!',
      emailAddress: 'E-Mail-Adresse',
      message: 'Nachricht',
      messagePlaceholder: 'Ihre Nachricht, einschließlich gewünschter Menge...',
      day: 'Datum',
      submit: 'Absenden',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      thankYou: 'Vielen Dank für Ihre Anfrage! Wir werden uns bald bei Ihnen melden.'
    },
    
    // Imprint Page
    imprint: {
      title: 'Impressum',
      companyInfo: 'Unternehmensinformationen',
      contact: 'Kontakt',
      phone: 'Telefon',
      email: 'E-Mail',
      website: 'Website',
      legalRep: 'Verantwortlicher',
      legalRepText: 'Verantwortlich für den Inhalt gemäß § 55 RStV:',
      disclaimer: 'Haftungsausschluss',
      contentLiability: 'Haftung für Inhalte',
      contentLiabilityText: 'Als Diensteanbieter sind wir gemäß den allgemeinen Gesetzen für eigene Inhalte auf diesen Seiten verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
      linkLiability: 'Haftung für Links',
      linkLiabilityText: 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
      copyright: 'Urheberrecht',
      copyrightText: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
      imageCredits: 'Bildquellen',
      imageCreditsText: 'Auf dieser Website verwendete Bilder und Grafiken stammen von:',
      imageSourcesList: [
        'Eigenes Material (Svansele Grönt)',
        'Unsplash (Platzhalterbilder)',
        'Leaflet / OpenStreetMap (Kartendaten)'
      ]
    },
    
    // Privacy Page
    privacy: {
      title: 'Datenschutzerklärung',
      intro: 'Einleitung',
      introText1: 'Bei Svansele Grönt legen wir großen Wert auf Ihre persönliche Privatsphäre. Diese Datenschutzerklärung beschreibt, wie wir Ihre personenbezogenen Daten erfassen, verwenden und schützen, wenn Sie unsere Website www.svanselegront.se besuchen oder uns für Bestellungen und Anfragen kontaktieren.',
      introText2: 'Wir sind verpflichtet, bei der Verarbeitung Ihrer personenbezogenen Daten das Datenschutzgesetz (DSGVO) und andere relevante Gesetze einzuhalten.',
      dataCollection: 'Welche Daten erfassen wir?',
      contactForms: 'Kontaktformulare und Bestellungen',
      contactFormsList: [
        'Name',
        'E-Mail-Adresse',
        'Telefonnummer (optional)',
        'Adresse (für Lieferungen)',
        'Bestellinformationen',
        'Nachrichten und Anfragen'
      ],
      websiteUsage: 'Website-Nutzung',
      websiteUsageList: [
        'IP-Adresse (für Sicherheitszwecke)',
        'Browsertyp und -version',
        'Betriebssystem',
        'Verweisende Websites',
        'Besuchsdatum und -zeit'
      ],
      dataUse: 'Wie wir Ihre Daten verwenden',
      dataUseText: 'Wir verwenden Ihre personenbezogenen Daten für folgende Zwecke:',
      dataUseList: [
        'Zur Verwaltung und Ausführung Ihrer Bestellungen',
        'Zur Beantwortung Ihrer Fragen und Anfragen',
        'Zur Verbesserung unserer Produkte und Dienstleistungen',
        'Zur Kommunikation mit Ihnen bezüglich Lieferungen und Neuigkeiten',
        'Zur Einhaltung geltender Gesetze und Vorschriften'
      ],
      dataSharing: 'Weitergabe von Daten',
      dataSharingText: 'Wir verkaufen oder vermieten Ihre personenbezogenen Daten niemals an Dritte. Wir geben Ihre Daten nur in folgenden Situationen weiter:',
      dataSharingList: [
        'Wenn dies zur Ausführung einer Bestellung erforderlich ist (z. B. an einen Spediteur)',
        'Wenn wir gesetzlich dazu verpflichtet sind',
        'Wenn Sie Ihre ausdrückliche Einwilligung gegeben haben'
      ],
      dataStorage: 'Datenspeicherung',
      dataStorageText1: 'Ihre personenbezogenen Daten werden nur so lange gespeichert, wie es für die Zwecke, für die sie erhoben wurden, erforderlich ist. Wir ergreifen geeignete technische und organisatorische Maßnahmen, um Ihre Daten vor unbefugtem Zugriff, Verlust oder Zerstörung zu schützen.',
      dataStorageText2: 'Kontaktformulare und Bestellungen werden maximal 2 Jahre nach der letzten Aktivität gespeichert, sofern nicht eine längere Speicherung gesetzlich vorgeschrieben ist.',
      yourRights: 'Ihre Rechte',
      yourRightsText: 'Gemäß der DSGVO haben Sie folgende Rechte in Bezug auf Ihre personenbezogenen Daten:',
      yourRightsList: [
        'Recht auf Auskunft darüber, welche Daten wir über Sie verarbeiten',
        'Recht auf Berichtigung falscher Daten',
        'Recht auf Löschung Ihrer Daten',
        'Recht auf Einschränkung der Verarbeitung Ihrer Daten',
        'Recht auf Widerspruch gegen die Verarbeitung',
        'Recht auf Datenübertragbarkeit'
      ],
      yourRightsFooter: 'Um diese Rechte auszuüben, kontaktieren Sie uns über die unten angegebenen Informationen.',
      cookies: 'Cookies',
      cookiesText1: 'Unsere Website verwendet nur notwendige Cookies für grundlegende Funktionen wie Navigation und grundlegende Sicherheit. Wir verwenden keine Cookies für Tracking oder Marketing.',
      cookiesText2: 'Sie können Cookies ablehnen, indem Sie die Einstellungen in Ihrem Browser ändern.',
      contactInfo: 'Kontakt',
      contactInfoText: 'Wenn Sie Fragen zu unserer Datenschutzerklärung oder zur Verarbeitung Ihrer personenbezogenen Daten haben, kontaktieren Sie uns:',
      changes: 'Änderungen der Richtlinie',
      changesText1: 'Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Alle Änderungen werden auf dieser Seite mit dem Datum der letzten Aktualisierung veröffentlicht.',
      changesText2: 'Zuletzt aktualisiert:'
    }
  },
  
  fr: {
    // PDF Section
    pdfSection: {
      title: 'Viola Svansele Grönt',
      downloadPDF: 'Télécharger le PDF'
    },
    
    // Navigation
    nav: {
      home: 'Accueil',
      currentPrices: 'Prix actuels',
      products: 'Produits',
      markets: 'Où acheter',
      contact: 'Contact',
      images: 'Images',
      wholesale: 'Vente en gros',
      imprint: 'Mentions légales',
      privacy: 'Politique de confidentialité'
    },
    
    // Hero Carousel
    hero: {
      ecological: 'Écologique',
      tasty: 'Délicieux',
      local: 'Local',
      marketsBtn: 'Marchés',
      productsBtn: 'Produits',
      imagesBtn: 'Images'
    },
    
    // Welcome Section
    welcome: {
      title: 'Bienvenue sur le site de Svansele Grönt',
      subtitle: 'Aliments biologiques de l\'arrière-pays de Västerbotten',
      findUsBtn: 'Nous trouver',
      ecologicalTitle: 'Écologique et cultivé localement',
      hopeSee: 'Nous espérons vous voir en 2026 !',
      cafeVisitors: 'Visiteurs du café de printemps'
    },
    
    // Product Showcase
    productShowcase: {
      currentInStore: 'Actuellement en magasin',
      notOnlyCarrots: 'Pas seulement des carottes',
      findMore: 'En savoir plus !'
    },
    
    // Why We Section
    whyWe: {
      title: 'Pourquoi Svansele Grönt existe',
      localRaw: {
        title: 'Matières premières locales',
        desc: 'Les aliments doivent être produits là où vivent les clients.',
        details: 'La production biologique et les courtes distances minimisent l\'empreinte écologique. Les consommateurs connaissent "leurs agriculteurs" et savent comment les aliments sont fabriqués.'
      },
      ownProducts: {
        title: 'Produits propres de la laiterie aux carottes',
        desc: 'Produire biologiquement - transformer les matières premières soi-même - commercialiser directement !',
        details: 'Sans transformation propre, pas d\'agriculture à petite échelle ! La laiterie est donc le cœur de l\'agriculture durable.'
      },
      preserveKnowledge: {
        title: 'Préserver les connaissances - Accroître la sensibilisation',
        desc: 'Tous les agriculteurs locaux font partie de la sécurité alimentaire stratégique.',
        details: 'Pour avoir suffisamment de nourriture même en période de flambée des prix du carburant ou d\'autres obstacles au transport mondial, des connaissances locales et des terres agricoles ouvertes sont nécessaires.'
      }
    },
    
    // Morotsmejeriet
    morotsmejeriet: {
      title: 'La Laiterie aux Carottes',
      intro: 'C\'est le nom de notre installation où nous travaillons. Ici, nous cuisinons de la confiture, des sauces et du sirop de pousses d\'épicéa, fermentons et séchons divers produits, etc.',
      fermentationTitle: 'À propos de la lacto-fermentation',
      fermentationText: 'Lorsque les légumes sont fermentés, des bactéries lactiques probiotiques se développent dans les légumes. Les bactéries convertissent le sucre en acide lactique, peroxyde d\'hydrogène et autres substances acides. Cela préserve les légumes sans détruire leur valeur nutritive. Les légumes fermentés sont bénéfiques de plusieurs façons. Ils :',
      benefits: [
        'sont riches en vitamine C.',
        'contiennent des bactéries probiotiques bénéfiques qui renforcent le système immunitaire, et des nutriments complexes tels que la vitamine B12 sont produits pendant la fermentation.',
        'abaissent l\'IG du repas.',
        'sont facilement digestibles.'
      ],
      conclusion: 'La vitamine C, les antioxydants et de nombreuses autres substances bénéfiques sont préservés. En même temps, de nombreuses substances bénéfiques deviennent plus disponibles et de nouveaux nutriments complexes tels que la vitamine B12 et les acides aminés sont formés par les bactéries bénéfiques.',
      readMore: 'En savoir plus (PDF)',
      imagePlaceholder: 'Image de la laiterie aux carottes'
    },
    
    // Footer
    footer: {
      images: 'Images',
      imprint: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      alitero: 'Un produit d\'Alitero EU',
      copyright: '© 2026 Svansele Grönt. Tous droits réservés.'
    },
    
    // Contact Page
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes heureux de vous aider pour toute question sur nos produits ou la vente en gros',
      sendMessage: 'Envoyer un message',
      name: 'Nom',
      email: 'E-mail',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer le message',
      contactInfo: 'Coordonnées',
      address: 'Adresse',
      phone: 'Téléphone',
      wholesaleTitle: 'Vente en gros',
      wholesaleText: 'Intéressé par l\'achat de nos produits en plus grandes quantités ? Contactez-nous pour des prix spéciaux et des options de livraison.',
      wholesaleList: [
        'Restaurants et cafés',
        'Magasins et coopératives',
        'Grands événements',
        'Livraisons d\'entreprise'
      ],
      thankYou: 'Merci pour votre message ! Nous vous répondrons dans les plus brefs délais.'
    },
    
    // Products Page
    products: {
      title: 'Nos produits',
      subtitle: 'Légumes biologiques',
      productImage: 'Image du produit',
      items: {
        carrots: 'Carottes',
        potatoes: 'Pommes de terre',
        whiteCabbage: 'Chou Blanc',
        pointCabbage: 'Chou Pointu',
        sauerkraut: 'Choucroute',
        spruceSyrup: 'Sirop de Pousses d\'Épicéa',
        whiteTurnip: 'Navet Blanc',
        yellowTurnip: 'Navet Jaune',
        rutabaga: 'Rutabaga',
        grillSauce: 'Sauce Grill aux Betteraves',
        redBeetsString: 'Rödbetstråån',
        carrotString: 'Morotstråån'
      }
    },

    // Price Page
    prices: {
      title: 'Prix actuels',
      subtitle: 'Vous trouverez ici nos prix actuels pour les produits biologiques de Svansele Grönt',
      inStore: 'Produits en magasin',
      updated: 'Mis à jour',
      inStock: 'En stock',
      orderItem: 'Article sur commande',
      seasonal: 'Saisonnier',
      limited: 'Limité',
      priceInfo: 'Informations sur les prix',
      general: 'Général',
      generalList: [
        'Tous les prix incluent la TVA',
        'Les prix saisonniers peuvent varier',
        'Date de fraîcheur garantie'
      ],
      wholesale: 'Vente en gros',
      wholesaleList: [
        'Remise sur les achats supérieurs à 500 kr',
        'Prix spéciaux pour les détaillants',
        'Contactez-nous pour un devis'
      ],
      note: 'Remarque : Les prix peuvent varier selon la saison et la disponibilité. Contactez-nous pour les prix les plus récents ou pour des commandes plus importantes.',
      products: {
        carrot: 'Carottes',
        fodderCarrot: 'Carottes Fourragères',
        potato: 'Pommes de terre – Gala, Nicola, Connect',
        potatoDitta: 'Pommes de terre – Ditta',
        almonPotato: 'Pommes de terre Amande',
        pointCabbage: 'Chou Pointu',
        whiteCabbage: 'Chou Blanc',
        redCabbage: 'Chou Rouge',
        rutabaga: 'Chou-rave',
        turnip: 'Navet – blanc ou jaune',
        fermentedWhiteCabbage: 'Choucroute',
        fermentedWhiteCabbageBottle: 'Choucroute (incl. 15: - consigne)',
        fermentedCarrot: 'Carottes Fermentées',
        fermentedMixed: 'Carottes/Choucroute Fermentés',
        beetsString: 'Rödbetstråån med lakrits',
        carrotString: 'Morotstråån med havtorn',
        grillSauce: 'Sauce Grill aux Betteraves Chaude',
        carrotSyrup: 'Sirop de Carottes Chaud',
        spruceSyrup: 'Sirop de Pousses d\'Épicéa',
        beetsKvass: 'Kvass aux Betteraves',
        carrotJuice: 'Jus de Carottes (Congelé ou Frais)',
        vegetableBroth: 'Bouillon de Légumes',
        redBeetsString: 'Rödbetstråån',
        carrotStringName: 'Morotstråån'
      }
    },
    
    // Markets Page
    markets: {
      farmShop: 'est ouverte 24h/24 et 7j/7. Vous y trouverez tout ce qui vient de la ferme et plus encore. La ferme est située à Svansele 2, 935 93 Norsjö.',
      lovanger: 'Kungsvägen 28, 932 61 Lövånger, lundi – vendredi : 10h-18h, samedi : 11h-15h. Visitez',
      burtrask: 'Vasabrogatan 3, est ouverte trois jours par semaine. Jeudi et vendredi 10h-18h et samedis 10h-14h. Visitez',
      skelleftea: 'a lieu les jeudis des semaines impaires de 18h00 à 18h30 au Tipshusparkeringen Anderstorp. Commandez via FB !',
      kusfors: 'Björks Lanthandel, Kusfors 33, 936 93 Boliden. Horaires : lundi–jeudi 9h30–18h00, vendredi 9h30–19h00, samedi 9h30–16h00, dimanche 12h00–16h00.',
      adak: 'Slagnäsvägen 5, 939 92 Adak, lundi – vendredi : 10h-17h30, samedi : 10h-12h, dimanche : 16h-17h.',
      wholesaleTitle: 'Pour les clients en gros',
      wholesaleText: 'Envoyez votre demande, commande ou demande de devis à :',
      wholesaleBtn: 'vente en gros',
      website: 'le site web du magasin !',
      farmShopName: 'La boutique de la ferme',
      lovangerName: 'Halle alimentaire de Lövånger',
      burtraskName: 'La Halle alimentaire de Burträsk (temporairement fermée)',
      skellefteaName: 'Le Cercle Reko de Skellefteå',
      kusforsName: 'ICA Kusfors',
      adakName: 'Le Commerçant d\'Adak',
      glommerstrak: 'Finnbergs, Storgatan 90, 933 94 Glommersträsk, lundi – vendredi : 9h-18h30, samedi : 9h-13h, dimanche : fermé.',
      glommerstrakName: 'Le Commerçant de Glommersträsk',
      farmup: 'La meilleure nourriture est près de chez vous. Achetez directement auprès des producteurs alimentaires de votre région.',
      farmupName: 'Farmup (bientôt)'
    },

    // Images Page
    images: {
      title: 'Images',
      subtitle: 'Un voyage visuel à travers Svansele Grönt - de notre agriculture biologique aux produits finis et aux places de marché',
      allImages: 'Toutes les images',
      branding: 'Image de marque',
      products: 'Produits',
      farm: 'Ferme & Culture',
      production: 'Laiterie aux Carottes',
      market: 'Marchés',
      events: 'Événements',
      followUs: 'Suivez-nous sur les réseaux sociaux',
      followText: 'Restez informé de tout ce qui se passe chez Svansele Grönt - des récoltes quotidiennes aux nouveaux produits et événements de marché'
    },
    
    // Wholesale Page
    wholesalePage: {
      title: 'Contactez-nous !',
      myNameIs: 'Mon nom est',
      yourName: 'Votre nom',
      iAm: 'Je suis',
      restaurateur: 'restaurateur',
      largeKitchen: 'une grande cuisine',
      privateCustomer: 'client privé',
      iWant: 'Je veux',
      order: 'commander',
      quote: 'un devis',
      regarding: 'Concernant',
      carrots: 'Carottes',
      potatoes: 'Pommes de terre',
      goodies: 'Friandises',
      spruceTipSyrup: 'Sirop de pousses d\'épicéa',
      grillSauce: 'Sauce grill',
      other: 'Autre',
      quantityNote: 'Veuillez spécifier la quantité dans le champ "Message" ci-dessous !',
      emailAddress: 'Adresse e-mail',
      message: 'Message',
      messagePlaceholder: 'Votre message, y compris la quantité souhaitée...',
      day: 'Date',
      submit: 'Envoyer',
      email: 'E-mail',
      phone: 'Téléphone',
      address: 'Adresse',
      thankYou: 'Merci pour votre demande ! Nous vous contacterons bientôt.'
    },
    
    // Imprint Page
    imprint: {
      title: 'Mentions légales',
      companyInfo: 'Informations sur l\'entreprise',
      contact: 'Contact',
      phone: 'Téléphone',
      email: 'E-mail',
      website: 'Site web',
      legalRep: 'Représentant légal',
      legalRepText: 'Responsable du contenu selon § 55 RStV :',
      disclaimer: 'Avis de non-responsabilité',
      contentLiability: 'Responsabilité du contenu',
      contentLiabilityText: 'En tant que fournisseur de services, nous sommes responsables de notre propre contenu sur ces pages conformément aux lois générales. Cependant, nous ne sommes pas obligés de surveiller les informations transmises ou stockées par des tiers ou d\'enquêter sur des circonstances indiquant une activité illégale.',
      linkLiability: 'Responsabilité des liens',
      linkLiabilityText: 'Notre offre contient des liens vers des sites web externes de tiers, sur le contenu desquels nous n\'avons aucune influence. Par conséquent, nous ne pouvons assumer aucune responsabilité pour ce contenu externe. Le fournisseur ou l\'exploitant respectif des pages est toujours responsable du contenu des pages liées.',
      copyright: 'Droits d\'auteur',
      copyrightText: 'Le contenu et les œuvres sur ces pages créés par les opérateurs du site sont soumis au droit d\'auteur. La copie, l\'édition, la distribution et toute forme d\'exploitation en dehors des limites du droit d\'auteur nécessitent le consentement écrit de l\'auteur ou du créateur respectif.',
      imageCredits: 'Sources d\'images',
      imageCreditsText: 'Les images et graphiques utilisés sur ce site web proviennent de :',
      imageSourcesList: [
        'Matériel propre (Svansele Grönt)',
        'Unsplash (Images d\'espace réservé)',
        'Leaflet / OpenStreetMap (Données cartographiques)'
      ]
    },
    
    // Privacy Page
    privacy: {
      title: 'Politique de confidentialité',
      intro: 'Introduction',
      introText1: 'Chez Svansele Grönt, nous nous soucions de votre vie privée. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos données personnelles lorsque vous visitez notre site web www.svanselegront.se ou nous contactez pour des commandes et des demandes.',
      introText2: 'Nous sommes tenus de respecter la loi sur la protection des données (RGPD) et d\'autres lois pertinentes lors du traitement de vos données personnelles.',
      dataCollection: 'Quelles données collectons-nous ?',
      contactForms: 'Formulaires de contact et commandes',
      contactFormsList: [
        'Nom',
        'Adresse e-mail',
        'Numéro de téléphone (facultatif)',
        'Adresse (pour les livraisons)',
        'Informations de commande',
        'Messages et demandes'
      ],
      websiteUsage: 'Utilisation du site web',
      websiteUsageList: [
        'Adresse IP (à des fins de sécurité)',
        'Type et version du navigateur',
        'Système d\'exploitation',
        'Sites web de référence',
        'Date et heure de la visite'
      ],
      dataUse: 'Comment nous utilisons vos données',
      dataUseText: 'Nous utilisons vos données personnelles aux fins suivantes :',
      dataUseList: [
        'Pour gérer et exécuter vos commandes',
        'Pour répondre à vos questions et demandes',
        'Pour améliorer nos produits et services',
        'Pour communiquer avec vous concernant les livraisons et les actualités',
        'Pour nous conformer aux lois et règlements applicables'
      ],
      dataSharing: 'Partage de données',
      dataSharingText: 'Nous ne vendons ni ne louons jamais vos données personnelles à des tiers. Nous ne partageons vos données que dans les situations suivantes :',
      dataSharingList: [
        'Lorsque cela est nécessaire pour exécuter une commande (par exemple, à un transporteur)',
        'Lorsque nous sommes tenus de le faire par la loi',
        'Lorsque vous avez donné votre consentement explicite'
      ],
      dataStorage: 'Stockage des données',
      dataStorageText1: 'Vos données personnelles ne sont stockées que le temps nécessaire aux fins pour lesquelles elles ont été collectées. Nous prenons des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou destruction.',
      dataStorageText2: 'Les formulaires de contact et les commandes sont conservés pendant un maximum de 2 ans après la dernière activité, sauf si un stockage plus long est requis par la loi.',
      yourRights: 'Vos droits',
      yourRightsText: 'Selon le RGPD, vous disposez des droits suivants concernant vos données personnelles :',
      yourRightsList: [
        'Droit à l\'information sur les données que nous traitons à votre sujet',
        'Droit de demander la correction de données incorrectes',
        'Droit de demander la suppression de vos données',
        'Droit de limiter le traitement de vos données',
        'Droit de vous opposer au traitement',
        'Droit à la portabilité des données'
      ],
      yourRightsFooter: 'Pour exercer ces droits, contactez-nous en utilisant les informations ci-dessous.',
      cookies: 'Cookies',
      cookiesText1: 'Notre site web n\'utilise que des cookies nécessaires pour les fonctions de base, telles que la navigation et la sécurité de base. Nous n\'utilisons pas de cookies pour le suivi ou le marketing.',
      cookiesText2: 'Vous pouvez choisir de refuser les cookies en modifiant les paramètres de votre navigateur.',
      contactInfo: 'Contact',
      contactInfoText: 'Si vous avez des questions sur notre politique de confidentialité ou sur la manière dont nous traitons vos données personnelles, contactez-nous :',
      changes: 'Modifications de la politique',
      changesText1: 'Nous pouvons mettre à jour cette politique de confidentialité de temps en temps. Toute modification sera publiée sur cette page avec la date de la dernière mise à jour.',
      changesText2: 'Dernière mise à jour :'
    }
  }
};